import React from "react";

// Modules
import { useEffect, useState } from "react";

import PageHeader from "../../partials/pageHeader";
import ListHeader from "../../partials/listHeader";
import { Row } from "react-bootstrap";
import TaxonomyItem from "./taxonomyItem";

const listLabels = [
  { title: "Category type", width: { xs: 3 }, className: "" },
  { title: "Description", width: { xs: 6 }, grow: true, colClass: "d-flex justify-content-center" },
  {
    title: "Operations",
    width: { xs: 3 },
    colClass: "justify-content-end d-flex",
  },
];

const TYPES = [
  {
    typeName: "news",
    typeLabel: "News categories",
    targetVid: "news_categories",
  },
  {
    typeName: "event",
    typeLabel: "Events categories",
    targetVid: "event_categories",
  },
  {
    typeName: "presentation",
    typeLabel: "Presentations categories",
    targetVid: "presentation_categories",
  },
  {
    typeName: "video",
    typeLabel: "Videos categories",
    targetVid: "video_categories",
  },
  {
    typeName: "gallery",
    typeLabel: "Galleries categories",
    targetVid: "gallery_categories",
  },
  {
    typeName: "podcast",
    typeLabel: "Podcasts categories",
    targetVid: "podcast_categories",
  },
  {
    typeName: "document",
    typeLabel: "Documents categories",
    targetVid: "document_categories",
  },
  {
    typeName: "training",
    typeLabel: "Training Courses categories",
    targetVid: "training_categories",
  },
  {
    typeName: "quiz",
    typeLabel: "Quizzes categories",
    targetVid: "quiz_categories",
  },
  {
    typeName: "link",
    typeLabel: "Links categories",
    targetVid: "link_categories",
  },
];

export default function Taxonomies(props) {
  const dataComponent = () => {
    return (
      <div className="taxonomies-container">
        {TYPES.map((item) => (
          <>
            <TaxonomyItem item={item} />
          </>
        ))}
      </div>
    );
  };

  return (
    <>
      <PageHeader
        pageName="Categories"
        filters={true}
        owner="client"
        pageNameColor="clientHeadingScreens"
        switchStatus={false}
      />
      <ListHeader
        items={listLabels}
        labelConfig={{
          owner: "client",
          variant: "subtitle1",
          color: "clientPrimary.main",
          weight: "medium",
          lh: "wide",
        }}
      />
      {dataComponent()}
    </>
  );
}
